import React from "react";
import {NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import {useLocationFormState} from "../../components/roadCarrier/RoadCarrierForm/RoadCarrierAddForm";
import RoadCarrierAddFormProvider from "../../components/roadCarrier/RoadCarrierForm/RoadCarrierAddFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const RoadCarrierAddEditPage = () => {

    useTitle(t`Add Road Carrier`);

    return (
        <Box data-testid="RoadCarrier-add-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="RoadCarrier-add-title"
                    >
                        <Trans>Add Road Carrier</Trans>
                    </Typography>
                    <RoadCarrierAddFormProvider
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default RoadCarrierAddEditPage;
